import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'z-mandate-terms-modal',
  standalone: false,
  templateUrl: './mandate-terms-modal.component.html'
})
export class MandateTermsModalComponent implements OnInit, OnDestroy {

  title: string;
  content: string;
  termsAccepted = false;

  constructor(
    public activeModal: NgbActiveModal,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'zing-ui-modal-backdrop');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'zing-ui-modal-backdrop');
  }

}
